export const seasonData = () => {
  return [
    {
      class: "field",
      title: "field suite",
      description:
        "Welcome to the <span>Field Suites,</span> our field level suite experience. Here, the highest level of baseball action unfolds so dramatically close, you'll feel like you should be in the starting lineup.<br><br>In a space thoughtfully designed for you to interact with your guests - for business or pleasure. Each suite is built to accommodate seven to nine people, and offers you an option to add additional standing room tickets.<br><br>Whether you're entertaining colleagues, friends or family, your Field Suite will leave a lasting impression on every single person who shares the experience with you.",
      perks: [
        {
          icon: require("@/assets/icons/icon_black_pin_location.svg"),
          text: "field level",
        },
        {
          icon: require("@/assets/icons/icon_black_parking.svg"),
          text: "2 vip reserved parking passes",
        },
        {
          icon: require("@/assets/icons/icon_black_ticket.svg"),
          text: "7-12 tickets",
        },
        {
          icon: require("@/assets/icons/icon_black_bell.svg"),
          text: "dedicated suite attendant",
        },
        {
          icon: require("@/assets/icons/icon_black_lock.svg"),
          text: "lexus club access & all-inclusive buffet",
        },
        {
          icon: require("@/assets/icons/icon_black_fork_knife.svg"),
          text: "$400 food & beverage credit per game",
        },
      ],
      slider: [
        require("@/assets/images/SeasonSuites/FieldSuites/field_1.jpg"),
        require("@/assets/images/SeasonSuites/FieldSuites/field_3.jpg"),
        require("@/assets/images/SeasonSuites/FieldSuites/field_4.jpg"),
      ],
      accordion: [
        // {
        //   icon: require("@/assets/icons/Benefits/icon_blue-big_pin-location.svg"),
        //   title: "suite location",
        //   description: "See where the Field Suites are located",
        //   image: require("@/assets/images/SuiteLocations/map_suite-locations_field.jpg"),
        // },
        {
          icon: require("@/assets/icons/icon_magnifying-glass.svg"),
          title: "compare suites",
          description: "Find the suite type that's right for you.",
          inside: [
            {
              title: "field suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "field level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "7-12 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-lock.svg"),
                  text: "lexus club access & all inclusive buffet",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$400 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "2 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
              ],
            },
            {
              title: "founders suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower concourse directly behind home plate",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "16-25 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-lock.svg"),
                  text: "private founders suite lounge",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$500 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
            {
              title: "legacy suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower concourse",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "18-30 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$800 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
            {
              title: "classic suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "Bailey & Galyen law suite level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "20 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$600 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "2-5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      class: "founders",
      title: "founders suite",
      description:
        "Welcome to the <span>Founders Suites</span>, a space so welcoming you may be tempted to move in. <br><br>Tucked behind home plate, enjoy a spacious interior layout that opens up to a sprawling view of Globe Life Field that is all yours to take in. Whether it’s for Rangers gamedays or exclusive events at Globe Life Field, a Founders Suite guarantees you an upscale experience and an unbeatable perspective of the game for you and your guests.",
      perks: [
        {
          icon: require("@/assets/icons/icon_black_pin_location.svg"),
          text: "lower concourse directly behind home plate",
        },
        {
          icon: require("@/assets/icons/icon_black_parking.svg"),
          text: "5 vip reserved parking passes",
        },
        {
          icon: require("@/assets/icons/icon_black_ticket.svg"),
          text: "16-25 tickets",
        },
        {
          icon: require("@/assets/icons/icon_black_bell.svg"),
          text: "dedicated suite attendant",
        },
        {
          icon: require("@/assets/icons/icon_black_lock.svg"),
          text: "private founders suite lounge",
        },
        {
          icon: require("@/assets/icons/icon_black_lock.svg"),
          text: "private restroom",
        },
        {
          icon: require("@/assets/icons/icon_black_fork_knife.svg"),
          text: "$500 food & beverage credit per game",
        },
      ],
      slider: [
        // require("@/assets/images/SeasonSuites/FoundersSuites/founders_1.jpg"),
        // require("@/assets/images/SeasonSuites/FoundersSuites/founders_2.jpg"),
        // require("@/assets/images/SeasonSuites/FoundersSuites/founders_3.jpg"),
        // require("@/assets/images/SeasonSuites/FoundersSuites/founders_4.jpg"),
        require("@/assets/images/SeasonSuites/FoundersNew/founders_01.jpg"),
        require("@/assets/images/SeasonSuites/FoundersNew/founders_02.jpg"),
        require("@/assets/images/SeasonSuites/FoundersNew/founders_03.jpg"),
        require("@/assets/images/SeasonSuites/FoundersNew/founders_04.jpg"),
        require("@/assets/images/SeasonSuites/FoundersNew/founders_05.jpg"),
        require("@/assets/images/SeasonSuites/FoundersNew/founders_06.jpg"),
        require("@/assets/images/SeasonSuites/FoundersNew/founders_07.jpg"),
        require("@/assets/images/SeasonSuites/FoundersNew/founders_08.jpg"),
        require("@/assets/images/SeasonSuites/FoundersNew/founders_09.jpg"),
        require("@/assets/images/SeasonSuites/FoundersNew/founders_10.jpg"),
        require("@/assets/images/SeasonSuites/FoundersNew/founders_11.jpg"),
        require("@/assets/images/SeasonSuites/FoundersNew/founders_12.jpg"),
      ],
      accordion: [
        // {
        //   icon: require("@/assets/icons/Benefits/icon_blue-big_pin-location.svg"),
        //   title: "suite location",
        //   description: "See where the Field Suites are located",
        //   image: require("@/assets/images/SuiteLocations/map_suite-locations_founders.jpg"),
        // },
        {
          icon: require("@/assets/icons/icon_magnifying-glass.svg"),
          title: "compare suites",
          description: "Find the suite type that's right for you.",
          inside: [
            {
              title: "field suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "field level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "7-12 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-lock.svg"),
                  text: "lexus club access & all inclusive buffet",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$400 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "2 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
              ],
            },
            {
              title: "founders suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower concourse directly behind home plate",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "16-25 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-lock.svg"),
                  text: "private founders suite lounge",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$500 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
            {
              title: "legacy suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower concourse",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "18-30 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$800 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
            {
              title: "classic suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "Bailey & Galyen law suite level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "20 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$600 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "2-5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      class: "legacy",
      title: "legacy suite",
      description:
        "Created with interaction and conversation in mind, this suite offers open spaces, fantastic views and incredible amenities that will enhace your experience.<br><br>The center of your suite features a dining area, where a thrilling variety of food and beverage will tempt you before and during the game. Choose from our expansive menu and customize a dining experience that suites your entertainment needs.",
      perks: [
        {
          icon: require("@/assets/icons/icon_black_pin_location.svg"),
          text: "lower concourse",
        },
        {
          icon: require("@/assets/icons/icon_black_bell.svg"),
          text: "dedicated suite attendant",
        },
        {
          icon: require("@/assets/icons/icon_black_ticket.svg"),
          text: "15-30 tickets",
        },
        {
          icon: require("@/assets/icons/icon_black_lock.svg"),
          text: "private restroom",
        },
        {
          icon: require("@/assets/icons/icon_black_fork_knife.svg"),
          text: "$800 food & beverage credit per game",
        },
        {
          icon: require("@/assets/icons/icon_black_parking.svg"),
          text: "5 vip reserved parking passes",
        },
      ],
      slider: [
        // require("@/assets/images/SeasonSuites/Legacy/legacy_1.jpg"),
        // require("@/assets/images/SeasonSuites/Legacy/legacy_2.jpg"),
        // require("@/assets/images/SeasonSuites/Legacy/legacy_3.jpg"),
        // require("@/assets/images/SeasonSuites/Legacy/legacy_4.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_1.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_2.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_3.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_4.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_5.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_6.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_7.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_8.jpg"),
        require("@/assets/images/SeasonSuites/LegacyNew/legacy_9.jpg"),
      ],
      accordion: [
        // {
        //   icon: require("@/assets/icons/Benefits/icon_blue-big_pin-location.svg"),
        //   title: "suite location",
        //   description: "See where the Field Suites are located",
        //   image: require("@/assets/images/SuiteLocations/map_suite-locations_legacy.jpg"),
        // },
        {
          icon: require("@/assets/icons/icon_magnifying-glass.svg"),
          title: "compare suites",
          description: "Find the suite type that’s right for you.",
          inside: [
            {
              title: "field suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "field level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "7-12 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-lock.svg"),
                  text: "lexus club access & all inclusive buffet",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$400 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "2 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
              ],
            },
            {
              title: "founders suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower concourse directly behind home plate",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "16-25 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-lock.svg"),
                  text: "private founders suite lounge",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$500 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
            {
              title: "legacy suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower concourse",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "18-30 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$800 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
            {
              title: "classic suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "Bailey & Galyen law suite level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "20 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$600 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "2-5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      class: "classic",
      title: "classic suite",
      description:
        "The most “traditional” suite offering at Globe Life Field. Spacious and inviting, you'll appreciate the attention to flow and detail of the <span>Classic Suites</span>, including the range of finishes from leather to metal.<br><br>Located on an exclusive concourse dedicated to suites, your Classic Suite will feel private and catered to your group’s needs. Each Classic Suite features a private restroom and wider ballpark seats that pair comfort with luxury.",
      perks: [
        {
          icon: require("@/assets/icons/icon_black_pin_location.svg"),
          text: "Bailey & Galyen law suite level",
        },
        {
          icon: require("@/assets/icons/icon_black_bell.svg"),
          text: "dedicated suite attendant",
        },
        {
          icon: require("@/assets/icons/icon_black_ticket.svg"),
          text: "20 tickets",
        },
        {
          icon: require("@/assets/icons/icon_black_lock.svg"),
          text: "private restroom",
        },
        {
          icon: require("@/assets/icons/icon_black_fork_knife.svg"),
          text: "$600 food & beverage credit per game",
        },
        {
          icon: require("@/assets/icons/icon_black_parking.svg"),
          text: "2-5 vip reserved parking passes",
        },
      ],
      slider: [
        // require("@/assets/images/SeasonSuites/ClassicSuites/classic_season20_1.jpg"),
        // require("@/assets/images/SeasonSuites/ClassicSuites/classic_season20_2.jpg"),
        // require("@/assets/images/SeasonSuites/ClassicSuites/classic_season20_3.jpg"),
        // require("@/assets/images/SeasonSuites/ClassicSuites/classic_season20_4.jpg"),
        // require("@/assets/images/SeasonSuites/ClassicSuites/classic_season20_5.jpg"),
        // require("@/assets/images/SeasonSuites/ClassicSuites/classic_season20_6.jpg"),
        require("@/assets/images/SeasonSuites/ClassicNew/classic_1.jpg"),
        require("@/assets/images/SeasonSuites/ClassicNew/classic_2.jpg"),
        require("@/assets/images/SeasonSuites/ClassicNew/classic_3.jpg"),
        require("@/assets/images/SeasonSuites/ClassicNew/classic_4.jpg"),
        require("@/assets/images/SeasonSuites/ClassicNew/classic_5.jpg"),
        require("@/assets/images/SeasonSuites/ClassicNew/classic_6.jpg"),
      ],
      accordion: [
        // {
        //   icon: require("@/assets/icons/Benefits/icon_blue-big_pin-location.svg"),
        //   title: "suite location",
        //   description: "See where the Field Suites are located",
        //   image: require("@/assets/images/SuiteLocations/map_suite-locations_classic-seasons.jpg"),
        // },
        {
          icon: require("@/assets/icons/icon_magnifying-glass.svg"),
          title: "compare suites",
          description: "Find the suite type that’s right for you.",
          inside: [
            {
              title: "field suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "field level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "7-12 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-lock.svg"),
                  text: "lexus club access & all inclusive buffet",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$400 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "2 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
              ],
            },
            {
              title: "founders suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower concourse directly behind home plate",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "16-25 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-lock.svg"),
                  text: "private founders suite lounge",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$500 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
            {
              title: "legacy suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "lower concourse",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "18-30 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$800 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
            {
              title: "classic suites",
              suiteItems: [
                {
                  icon: require("@/assets/icons/Benefits/icon_white-small_pin-location.svg"),
                  text: "Bailey & Galyen law suite level",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_ticket.svg"),
                  text: "20 tickets",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "$600 food & beverage credit per game",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white_fork-knife.svg"),
                  text: "2-5 vip reserved parking passes",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "dedicated suite attendant",
                },
                {
                  icon: require("@/assets/icons/Benefits/icon_white-big_bell.svg"),
                  text: "private restroom",
                },
              ],
            },
          ],
        },
      ],
    },
  ];
};
